
export { authStore$ } from "/opt/atlassian/pipelines/agent/build/packages/modules/module-core/src/modules/auth/stores/index.ts"